module.exports = __webpack_public_path__ + "img/ab9714a5fa156ed31a80b9bd75ca01b0.gif";